module.exports = __webpack_public_path__ + "static/img/4.45b23a0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/4/eng/4.png
// module id = qpbb
// module chunks = 0